@if (showToast) {
  <plugins-notice
    type="toast-float"
    [color]="data.color ?? ''"
    (dismiss)="onClose()"
    @toast
    (@toast.done)="onAnimationDone()"
  >
    @let message = data.message | nl2br;
    @if (message) {
      <div [innerHTML]="message | dompurify"></div>
    }
  </plugins-notice>
}
